// extracted by mini-css-extract-plugin
export var chip = "_5p-9";
export var chipLabel = "_5p-a";
export var close = "_5p-7";
export var closeIcon = "_5p-8";
export var error = "_5p-6";
export var infoTooltip = "_5p-2";
export var innerContainer = "_5p-1";
export var input = "_5p-b";
export var medium = "_5p-5";
export var outerContainer = "_5p-0";
export var small = "_5p-4";
export var xSmall = "_5p-3";